import React from 'react';
import { AppNavbar } from './AppNavbar';
import { AppFooter } from './AppFooter';
import { useApp } from '../../contexts/AppContext';
import '../../styles/AppLayout.css';

export const AppLayout = ({ children }) => {
  const { 
    getPrimaryColor,
    getSecondaryColor,
    appConfig 
  } = useApp();

  // Apply app-specific styles
  React.useEffect(() => {
    // Update CSS variables for theming
    document.documentElement.style.setProperty('--primary-color', getPrimaryColor());
    document.documentElement.style.setProperty('--secondary-color', getSecondaryColor());

    // Update favicon if provided
    if (appConfig?.favicon_url) {
      const favicon = document.querySelector('link[rel="icon"]');
      if (favicon) {
        favicon.href = appConfig.favicon_url;
      }
    }

    // Update title
    if (appConfig?.name) {
      document.title = appConfig.name;
    }

    // Apply custom CSS if provided
    if (appConfig?.custom_css) {
      const style = document.createElement('style');
      style.textContent = appConfig.custom_css;
      style.id = 'app-custom-css';
      
      // Remove any existing custom CSS
      const existingStyle = document.getElementById('app-custom-css');
      if (existingStyle) {
        existingStyle.remove();
      }
      
      document.head.appendChild(style);
    }

    // Fix for scrolling issues - ensure body and html have proper height and overflow
    document.body.style.height = '100%';
    document.body.style.overflowY = 'auto';
    document.documentElement.style.height = '100%';
    document.documentElement.style.overflowY = 'auto';

    // Cleanup function
    return () => {
      const customStyle = document.getElementById('app-custom-css');
      if (customStyle) {
        customStyle.remove();
      }
    };
  }, [appConfig, getPrimaryColor, getSecondaryColor]);

  return (
    <div className="app-layout">
      <AppNavbar />
      
      <main className="app-main">
        {children}
      </main>
      
      <AppFooter />
    </div>
  );
}; 